import { render, staticRenderFns } from "./CareGoals.vue?vue&type=template&id=5b6ec37c&scoped=true"
import script from "./CareGoals.vue?vue&type=script&lang=ts"
export * from "./CareGoals.vue?vue&type=script&lang=ts"
import style0 from "./CareGoals.vue?vue&type=style&index=0&id=5b6ec37c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ec37c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6ec37c')) {
      api.createRecord('5b6ec37c', component.options)
    } else {
      api.reload('5b6ec37c', component.options)
    }
    module.hot.accept("./CareGoals.vue?vue&type=template&id=5b6ec37c&scoped=true", function () {
      api.rerender('5b6ec37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/ClientRightSide/CareGoals.vue"
export default component.exports